import ActionsForm from '@/shared/mixins/actionsForm'
import addEpiApr from '../addEpiApr/addEpiApr.vue'
import aprTemplateEpiRepository from '@/shared/http/repositories/business/aprTemplateEpi'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  props: ['aprId', 'revisao', 'aprTemplateReprovado', 'templateClonado'],
  name: 'tableEpi',
  components: {addEpiApr},
  mixins: [ActionsForm],
  data () {
    return {
      columTemplate: ['EPI', 'STATUS', 'TIPO DE MUDANÇA', 'DATA DE CADASTRO', ''],
      dataEPITemplateAPR: [],
      dataEpiBusca: {}
    }
  },
  watch: {
    templateClonado (newValue) {
      if (newValue !== null || newValue !== undefined) {
        this.dataEpiBusca = {APRId: newValue.id, Revisao: newValue.revisao}
        aprTemplateEpiRepository.GetAPRTemplateEPIGrid(this.$refs.tableGridsTemplateAprEpi.pagingLimit, this.$refs.tableGridsTemplateAprEpi.pagingIndex, this.dataEpiBusca)
          .then((Response) => {
            loading.pop()
            // this.$refs.tableGridsTemplateAprEpi.LoadAllByData(Response)
            this.dataEPITemplateAPR = Response.data.data
          }).catch(Error => {
            loading.pop()
            toast.error('Erro ao carregar as informações')
          })
      }
    }
  },
  methods: {
    popUptAddEpi () {
      this.$refs['add-epi'].show()
    },
    cancelarEpi () {
      this.$refs['add-epi'].hide()
    },
    onLoad (value) {
      if (this.revisao !== -1 || value != null) {
        loading.push()
        if (value !== undefined && value !== null) {
          this.dataEpiBusca = {APRId: this.aprId, Revisao: value}
          aprTemplateEpiRepository.GetAPRTemplateEPIGrid(this.$refs.tableGridsTemplateAprEpi.pagingLimit, this.$refs.tableGridsTemplateAprEpi.pagingIndex, this.dataEpiBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprEpi.LoadAllByData(Response)
              this.dataEPITemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
              toast.error('Erro ao carregar as informações')
            })
        } else {
          this.dataEpiBusca = {APRId: this.aprId, Revisao: this.revisao}
          aprTemplateEpiRepository.GetAPRTemplateEPIGrid(this.$refs.tableGridsTemplateAprEpi.pagingLimit, this.$refs.tableGridsTemplateAprEpi.pagingIndex, this.dataEpiBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprEpi.LoadAllByData(Response)
              this.dataEPITemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
              toast.error('Erro ao carregar as informações')
            })
        }
      }
    },
    salvarEpi (valeu) {
      this.$emit('salvarEpi', valeu)
    },
    AdicionarTableEPI (value) {
      this.dataEPITemplateAPR.push(...value)
      this.$refs['add-epi'].hide()
    },
    DeletePopup (value) {
      loading.push()
      if (value.AgEnvio !== undefined && value.AgEnvio !== null && value.AgEnvio !== false) {
        this.dataEPITemplateAPR = this.dataEPITemplateAPR.filter(epi => epi.epiId !== value.epiId)
        this.$emit('removerListaDeAlteracoesEPI', value)
        loading.pop()
      } else {
        for (let i = 0; i < this.dataEPITemplateAPR.length; i++) {
          if (this.dataEPITemplateAPR[i].epiId === value.epiId) {
            this.dataEPITemplateAPR[i].statusAprovacao = null
            this.dataEPITemplateAPR[i].statusAprovacaoDescricao = 'AG. ENVIO'
            this.dataEPITemplateAPR[i].tipoMudanca = 'AG. ENVIO EXCLUSÃO'
            this.dataEPITemplateAPR[i].dateCricaoFormatada = null
            let dados = {
              APRId: this.aprId,
              epi: value.epiId,
              APRAgAprovacaoId: value.arpTemplateAgAprovacaoId
            }
            this.$emit('excluirEpi', dados)
          }
        }
        loading.pop()
      }
      loading.pop()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/tableEpi/tableEpi.js